export default class TextHelper {
    static toProperCase = (text: string) => {
        const strings = text.split(/(?=[A-Z])/).map((s) => s.charAt(0).toUpperCase() + s.slice(1));
        return strings.join(' ');
    };
}



// WEBPACK FOOTER //
// ./src/util/Text.ts